import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {HEAP_PROJECT_ID} from 'app/app.constants';
import {SettingsService} from 'app/common/settings.service';
import {ENABLE_ACTION_LOGGING} from 'app/constants/setting';
import {environment} from 'environments/environment';

declare let heap: any;
declare global {
    interface Window {
        heapReadyCb: any[];
        heap: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class HeapService {
    private renderer: Renderer2;

    constructor(
        private settingsService: SettingsService,
        private rendererFactory: RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    init() {
        this.settingsService.subscribeToSetting(ENABLE_ACTION_LOGGING, (value) => {
            if (value && HEAP_PROJECT_ID) {
                this.loadHeap();
            }
        });
    }

    private loadHeap() {
        window.heapReadyCb = window.heapReadyCb || [];
        window.heap = window.heap || [];
        window.heap.envId = HEAP_PROJECT_ID;
        window.heap.clientConfig = {};
        window.heap.clientConfig.shouldFetchServerConfig = false;

        const a = this.renderer.createElement('script');
        a.type = 'text/javascript';
        a.async = true;
        a.src = 'https://cdn.us.heap-api.com/config/' + HEAP_PROJECT_ID + '/heap_config.js';

        this.renderer.appendChild(document.head, a);

        const n = [
            'init',
            'startTracking',
            'stopTracking',
            'track',
            'resetIdentity',
            'identify',
            'getSessionId',
            'getUserId',
            'getIdentity',
            'addUserProperties',
            'addEventProperties',
            'removeEventProperty',
            'clearEventProperties',
            'addAccountProperties',
            'addAdapter',
            'addTransformer',
            'addTransformerFn',
            'onReady',
            'addPageviewProperties',
            'removePageviewProperty',
            'clearPageviewProperties',
            'trackPageview'
        ];
        const i = function (e: string) {
            return function (...args: any[]) {
                window.heapReadyCb.push({
                    name: e,
                    fn: function () {
                        window.heap[e] && window.heap[e](...args);
                    }
                });
            };
        };

        for (let p = 0; p < n.length; p++) {
            window.heap[n[p]] = i(n[p]);
        }
    }

    identify(identity: any) {
        this.settingsService.subscribeToSetting(ENABLE_ACTION_LOGGING, (value) => {
            if (value && HEAP_PROJECT_ID) {
                heap.identify(identity.id);
                heap.addUserProperties({
                    tenant: identity.currentTenant,
                    username: `${identity.firstName} ${identity.lastName}`,
                    role: identity.roles.toString(),
                    env: environment.env
                });
            }
        });
    }

    track(eventName: string, eventProps: any) {
        this.settingsService.subscribeToSetting(ENABLE_ACTION_LOGGING, (value) => {
            if (value && HEAP_PROJECT_ID) {
                heap.track(eventName, eventProps);
            }
        });
    }
}
